angular.module('app').controller( 'TokenLoginCtrl', [ '$location', '$log', '$rootScope', '$scope', '$state', '$stateParams',
    'aprgettext', 'AprimaAnalytics', 'Bridge', 'configuration', 'ConsentService', 'ContentAttributeService', 'GatewayFactory',
    'LocalStorageRepository', 'LogOffService', 'LoginAssistanceRepository', 'PatientPortalStorageRepository', 'SessionService', 'TransitionManager',
    function ($location, $log, $rootScope, $scope, $state, $stateParams,
              gettext, AprimaAnalytics, Bridge, configuration, ConsentService, ContentAttributeService, GatewayFactory,
              LocalStorageRepository, LogOffService, LoginAssistanceRepository, PatientPortalStorageRepository, SessionService, TransitionManager) {
        'use strict';

        $log.info('TokenLoginCtrl starting up');

        AprimaAnalytics.sendPageView('/Logon');
        LogOffService.logoff();
        SessionService.resetSessionParams();
        PatientPortalStorageRepository.removeActivePatient();

        $scope.errorMessage = '';
        $scope.submitted = false;
        $scope.loading = false;
        $scope.gateways = _.map(_.cloneDeep(configuration.GATEWAYS), function (g) {
            g.display = g.prefix + ' - ' + g.url;
            return g;
        });

        $scope.loginAssistanceInfo = null;

        $scope.model = {
            clientID: LocalStorageRepository.getClientID() || '0',
            userName: LocalStorageRepository.getUserName() || '',
            userId: LocalStorageRepository.getUserID() || null,
            password: '',
            gateway: null,
            practiceName: '',
            practiceTagline: '',
        };

        if (!configuration.DEV_HOSTED) {
            ContentAttributeService.getClientConfig()
                .then(function (data) {
                    var oldClientId = LocalStorageRepository.getClientID();

                    if (oldClientId !== data.clientId) {
                        LocalStorageRepository.clearAll();
                    }

                    LocalStorageRepository.setClientURL(data.hostUrl);
                    LocalStorageRepository.setClientID(data.clientId);

                    $scope.model.clientID = LocalStorageRepository.getClientID();
                    login();
                }).catch(function () {
                $scope.errorMessage = gettext('Error loading page. Unknown Client Id');
                Bridge.createModalAlert({
                    title: gettext('Loading Error'),
                    message: $scope.errorMessage,
                    buttons: [gettext('Okay')]
                });
            });
        } else {
            login();
        }

        function login() {
            $scope.loading = true;

            GatewayFactory.tokenLogin(LocalStorageRepository.getClientID(), $scope.model.gateway ? $scope.model.gateway.prefix : null, $stateParams.token)
                .then(function () {
                    // Broadcast event to start application timeout logic.
                    // Please see 'modules\app\app.js' for application timeout configuration and documentation.
                    $rootScope.$broadcast('IdleStartWatch');

                    SessionService.setPatientAuthenticated(true);
                    if (SessionService.getNewPasswordRequired() === true) {
                        SessionService.setDisplayDashboardToolbar(false);
                        SessionService.setShowHeaderNavigationMenu(false);
                        TransitionManager.transition({appRoute: 'changepassword'});
                    }
                    else if (SessionService.getPracticeConsentAccepted() === true) {
                        SessionService.setDisplayDashboardToolbar(true);
                        SessionService.setShowHeaderNavigationMenu(true);
                        TransitionManager.transition({appRoute: 'dashboard'});
                    }
                    else {
                        SessionService.setDisplayDashboardToolbar(false);
                        SessionService.setShowHeaderNavigationMenu(false);
                        TransitionManager.transition({appRoute: 'loginconsent'});
                    }
                }, function (err) {
                    $scope.errorMessage = err.message;

                    Bridge.createModalAlert({
                        title: gettext('Login Error'),
                        message: err.message,
                        buttons: [gettext('Okay')]
                    });
                })
                .finally(function () {
                    $scope.loading = false;
                });
        }
    }
]);
